module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/icons-ec763292e583294612f124c0b0def500.svg";